import { Box, Container, GridItem, SimpleGrid } from '@chakra-ui/react';
import { GetServerSidePropsContext } from 'next';

import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';

import ArticleContent from '@/components/Article/articleContent';
import { H1 } from '@/components/Heading';
import Seo from '@/components/Seo';

import { LocaleProps } from '@/models/props/LocalizationProps';
import { OpportunityProps } from '@/models/props/OpportunitiesProps';
import { OpportunitiesService } from '@/services/OpportunitiesService';

type SingleOpoortunityProps = {
    post: OpportunityProps;
};

const OpportunityPage = (props: SingleOpoortunityProps) => {
    const { post } = props;
    const { attributes } = post;

    return (
        <>
            <Seo title={attributes.title} description={attributes.shortDescription} />
            <Container as="section" maxW="container.2xl">
                <Box as="article" pt={10}>
                    <Box textAlign="center">
                        <H1>{attributes.title}</H1>
                    </Box>
                    <SimpleGrid columns={{ xl: 6 }} spacing={{ xl: 7 }}>
                        <GridItem />
                        <GridItem colSpan={{ xl: 4 }}>
                            <ArticleContent content={attributes.content} styles={{ pl: 0 }} />
                        </GridItem>
                    </SimpleGrid>
                </Box>
            </Container>
        </>
    );
};

export const getServerSideProps = withCommonServerSideProps(
    async (context: GetServerSidePropsContext) => {
        const { query, locale } = context;
        const { slug } = query;
        const postData = await OpportunitiesService.getPostBySlug(
            locale as LocaleProps,
            slug as string
        );

        if (!postData || !postData === null) {
            return {
                notFound: true
            };
        }

        return {
            props: {
                post: postData
            }
        };
    }
);

export default OpportunityPage;
